import type { OnPipeAssumptions } from "../models/types";

/** Defaults aligned with the sample assumptions PUT payload. */
export const DEFAULT_ON_PIPE_ASSUMPTIONS: OnPipeAssumptions = {
  blastFrame: {
    smallHeadMaxSteelOdMm: 323.84,
    smallHeadSealChordMm: 85,
    largeHeadSealChordMm: 134.02,
    twoTieBarHeadPlateWidthMm: 222,
    fourTieBarHeadPlateWidthMm: 121,
    chamferSideClearanceMm: 25,
    cwcOverallLengthMarginMm: 10,
  },
  inductionCoil: {
    coatingClearanceMm: 23,
    preferredNonCwcVersionId: "V8",
    stepDownCoatingThicknessMm: 66,
    chamferClearanceMm: 50,
    cwcLengthMarginMm: 10,
  },
};
